import { RefundType } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { RadioGroup } from '@dreryk/react-components';

import { AdvancePaymentsSettingsFormController } from '../AdvancePaymentsSettingsForm.types';

import { useRefundTypeRadioItems } from './RefundTypeField.hooks';

type RefundTypeFieldProps = Pick<AdvancePaymentsSettingsFormController, 'register' | 'watch'>;

export const RefundTypeField = (props: RefundTypeFieldProps): JSX.Element => {
   const items = useRefundTypeRadioItems({ register: props.register, watch: props.watch });

   return <RadioGroup<RefundType> testId={'refundType'} items={items} controller={props.register('refundType')} />;
};
